
import { useState, useEffect, useRef } from 'react';

const TESTIMONIALS = [
  {
    quote: 'Sylman Academy transformed our HR department. Their learnerships are practical, industry-relevant, and fully SETA-compliant. We\'ve seen remarkable improvements in staff retention.',
    name: 'Nomvula Dlamini', role: 'HR Director', company: 'PanAfrican Retail Group', initials: 'ND', rating: 5,
  },
  {
    quote: 'The SETA compliance support alone saved us hundreds of thousands in potential penalties. Their team understands the regulatory landscape inside out.',
    name: 'Brian Mokoena', role: 'Skills Development Manager', company: 'Mining Solutions SA', initials: 'BM', rating: 5,
  },
  {
    quote: 'We\'ve partnered with Sylman Academy for three years running. The facilitators are exceptional and the materials are truly world-class.',
    name: 'Priya Naidoo', role: 'L&D Lead', company: 'Cape Financial Services', initials: 'PN', rating: 5,
  },
  {
    quote: 'From enrolment through to certification, the process was incredibly smooth. Our learners were engaged and the completion rate exceeded all expectations.',
    name: 'Sipho Khumalo', role: 'Operations Director', company: 'Gauteng Manufacturing Co.', initials: 'SK', rating: 5,
  },
  {
    quote: 'As a B-BBEE Level 1 provider, Sylman Academy helps us meet scorecard targets while genuinely upskilling our workforce. Highly recommended.',
    name: 'Adri van der Merwe', role: 'CEO', company: 'Bespoke Tech Solutions', initials: 'AV', rating: 5,
  },
];

export default function TestimonialsSection() {
  const [current, setCurrent] = useState(0);
  const [paused,  setPaused]  = useState(false);
  const timer = useRef<ReturnType<typeof setInterval> | null>(null);

  useEffect(() => {
    if (paused) return;
    timer.current = setInterval(() => setCurrent(c => (c + 1) % TESTIMONIALS.length), 5000);
    return () => { if (timer.current) clearInterval(timer.current); };
  }, [paused]);

  const shown = [0, 1, 2].map(offset => TESTIMONIALS[(current + offset) % TESTIMONIALS.length]);

  return (
    <section className="section-wrap bg-[#f0f9f2]">
      <div className="section-inner">
        <div className="text-center mb-14 reveal">
          <p className="section-label justify-center">What Our Clients Say</p>
          <h2 className="section-heading mx-auto" style={{ maxWidth: '460px' }}>
            Trusted by Leading Organisations
          </h2>
        </div>

        <div
          className="grid grid-cols-1 md:grid-cols-3 gap-5 mb-10 reveal-children"
          onMouseEnter={() => setPaused(true)}
          onMouseLeave={() => setPaused(false)}
        >
          {shown.map((t, i) => (
            <div
              key={`${current}-${i}`}
              className={`card p-7 flex flex-col ${i === 0 ? 'border-[#c8e6cf] shadow-[0_4px_24px_rgba(45,127,62,0.1)]' : ''}`}
            >
              <div className="flex gap-0.5 mb-4">
                {Array.from({ length: t.rating }).map((_, s) => <i key={s} className="ri-star-fill text-[#2D7F3E] text-sm" />)}
              </div>
              <i className="ri-double-quotes-l text-3xl text-[#c8e6cf] mb-3" />
              <p className="text-[#3d3f42] text-sm leading-relaxed flex-1 mb-6">"{t.quote}"</p>
              <div className="flex items-center gap-3 pt-5 border-t border-[#e8eaea]">
                <div className="w-10 h-10 rounded-full bg-[#2D7F3E] flex items-center justify-center flex-shrink-0">
                  <span className="text-white text-xs font-bold">{t.initials}</span>
                </div>
                <div>
                  <div className="text-sm font-bold text-[#111111]">{t.name}</div>
                  <div className="text-xs text-[#6b7280]">{t.role} · {t.company}</div>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="flex justify-center gap-2">
          {TESTIMONIALS.map((_, i) => (
            <button
              key={i}
              onClick={() => setCurrent(i)}
              className={`rounded-full transition-all duration-300 cursor-pointer ${
                i === current ? 'w-6 h-2 bg-[#2D7F3E]' : 'w-2 h-2 bg-[#c8e6cf] hover:bg-[#2D7F3E]'
              }`}
              aria-label={`Testimonial ${i + 1}`}
            />
          ))}
        </div>
      </div>
    </section>
  );
}
